import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { APPROVAL_LIST } from './type';

export const getApprovalList = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.approvals.locApprovalList}?page=${page}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: APPROVAL_LIST, payload: data.response.data });
    return true;
  }
};

export const acceptApproval = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.approvals.locApprovalAccept}${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: '', payload: data.response.data });
    return true;
  }
};

export const rejectApproval = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.approvals.locApprovalReject}${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: '', payload: data.response.data });
    return true;
  }
};
